// dropdown multilevel
$('.dropdown-menu > li > .dropdown-menu').parent().addClass('dropdown-submenu').find(' > .dropdown-item').attr('href', 'javascript:;').addClass('dropdown-toggle');
$('.dropdown-submenu > a').on("click", function (e) {
    $(this).next('.dropdown-menu').toggleClass('show');

    // Go to link only on second tap for parent dropdown link
    if ($(window).width() < 992) {
        if ($(this).attr('aria-expanded')!=='true') {
            e.preventDefault();
        }
    }

    // Toggle aria expanded attr on child submenus
    $(this).attr('aria-expanded', function (i, attr) {
        return attr === 'true' ? 'false' : 'true';
    });

    e.stopPropagation();
});

// hide all open menus if the parent closes
$('.dropdown').on("hidden.bs.dropdown", function () {
    $('.dropdown-menu.show').removeClass('show');
    $('.dropdown-toggle').attr('aria-expanded', 'false');
});

// Add class on body so it won't be scrollable when the menu is open on mobile

$('#menu-navbar-collapse').on('show.bs.collapse', function () {
    $('body').addClass('open-menu');
});

$('#menu-navbar-collapse').on('hide.bs.collapse', function () {
    $('body').removeClass('open-menu');
});



// WEBPACK FOOTER //
// ./scripts/custom/wp-menu-fix.js